import React from 'react';
import PropTypes from 'prop-types';

export const colors = [
  '#8ed43d', // Atlantis
  '#f7d633', // Saffron
  '#888888', // Gray
  '#cccccc', // Silver
  '#9012fe', // Vivid Purple
  '#3882b6' // Windows Blue
];

export const CustomWidth = props => {
  const style = {
    width: `${
      props.elements * props.spacing > props.minimum
        ? props.elements * props.spacing
        : props.minimum
    }px`,
    height: '100%'
  };

  return (
    <div className="chart-export" style={style}>
      {props.children}
    </div>
  );
};

CustomWidth.propTypes = {
  children: PropTypes.node,
  elements: PropTypes.number.isRequired,
  spacing: PropTypes.number.isRequired,
  minimum: PropTypes.number.isRequired
};

CustomWidth.defaultProps = {
  children: () => null
};

export const CustomHeight = props => {
  const style = {
    width: '100%',
    height: `${
      props.elements * props.spacing > props.minimum
        ? props.elements * props.spacing
        : props.minimum
    }px`
  };

  return (
    <div className="chart-export" style={style}>
      {props.children}
    </div>
  );
};

CustomHeight.propTypes = {
  children: PropTypes.node,
  elements: PropTypes.number.isRequired,
  spacing: PropTypes.number.isRequired,
  minimum: PropTypes.number.isRequired
};

CustomHeight.defaultProps = {
  children: () => null
};

export default {
  colors,
  CustomWidth,
  CustomHeight
};
